// Auth pages
import InvitationPage from '@features/auth/pages/InvitationPage';
import ResetPasswordPage from '@features/auth/pages/ResetPasswordPage';
import SigninPage from '@features/auth/pages/SigninPage';
import SignupPage from '@features/auth/pages/SignupPage';
import VerifyEmailPage from '@features/auth/pages/VerifyEmailPage';

// Legal pages
import PrivacyPolicyPage from '@features/legal/pages/PrivacyPolicyPage';
import TermsConditionsPage from '@features/legal/pages/TermsConditionsPage';

// Organizations pages
import OrganizationProfile from '@features/organizations/pages/OrganizationProfile';
import Organizations from '@features/organizations/pages/Organizations';

// Settings pages
import AdminInvitationsSettings from '@features/settings/pages/AdminInvitationsSettings';
import MemberInvitationsManagement from '@features/settings/pages/MemberInvitationsManagement';
import OrganizationSettingsPage from '@features/settings/pages/OrganizationSettings';

// Onboarding pages
import Onboarding01Page from '@features/onboarding/pages/Onboarding01Page';
import Onboarding02Page from '@features/onboarding/pages/Onboarding02Page';
import Onboarding03Page from '@features/onboarding/pages/Onboarding03Page';
import Onboarding04Page from '@features/onboarding/pages/Onboarding04Page';

// Dashboard pages
/* import Analytics from '../pages/Analytics';
import Dashboard from '../pages/Dashboard';
import Fintech from '../pages/Fintech';

// E-commerce pages
import Cart from '../pages/ecommerce/Cart';
import Cart2 from '../pages/ecommerce/Cart2';
import Cart3 from '../pages/ecommerce/Cart3';
import Customers from '../pages/ecommerce/Customers';
import Invoices from '../pages/ecommerce/Invoices';
import Orders from '../pages/ecommerce/Orders';
import Pay from '../pages/ecommerce/Pay';
import Product from '../pages/ecommerce/Product';
import Shop from '../pages/ecommerce/Shop';
import Shop2 from '../pages/ecommerce/Shop2';

// Campaign pages
import Campaigns from '../pages/Campaigns';

// Community pages
import Feed from '../pages/community/Feed';
import Forum from '../pages/community/Forum';
import ForumPost from '../pages/community/ForumPost';
import Meetups from '../pages/community/Meetups';
import MeetupsPost from '../pages/community/MeetupsPost';
import Profile from '../pages/community/Profile';
import UsersTabs from '../pages/community/UsersTabs';
import UsersTiles from '../pages/community/UsersTiles';

// Finance pages
import CreditCards from '../pages/finance/CreditCards';
import TransactionDetails from '../pages/finance/TransactionDetails';
import Transactions from '../pages/finance/Transactions';

// Job pages
import CompanyProfile from '../pages/job/CompanyProfile';
import JobListing from '../pages/job/JobListing';
import JobPost from '../pages/job/JobPost';

// Messaging and tasks
import Calendar from '../pages/Calendar';
import Inbox from '../pages/Inbox';
import Messages from '../pages/Messages';
import TasksKanban from '../pages/tasks/TasksKanban';
import TasksList from '../pages/tasks/TasksList';

// Settings pages
import Account from '../pages/settings/Account';
import Apps from '../pages/settings/Apps';
import Billing from '../pages/settings/Billing';
import Feedback from '../pages/settings/Feedback';
import Notifications from '../pages/settings/Notifications';
import Plans from '../pages/settings/Plans';

// Utility pages
import Changelog from '../pages/utility/Changelog';
import EmptyState from '../pages/utility/EmptyState';
import Faqs from '../pages/utility/Faqs';
import Roadmap from '../pages/utility/Roadmap';

// Component pages
import AccordionPage from '../pages/component/AccordionPage';
import AlertPage from '../pages/component/AlertPage';
import AvatarPage from '../pages/component/AvatarPage';
import BadgePage from '../pages/component/BadgePage';
import BreadcrumbPage from '../pages/component/BreadcrumbPage';
import ButtonPage from '../pages/component/ButtonPage';
import DropdownPage from '../pages/component/DropdownPage';
import FormPage from '../pages/component/FormPage';
import IconsPage from '../pages/component/IconsPage';
import ModalPage from '../pages/component/ModalPage';
import PaginationPage from '../pages/component/PaginationPage';
import TabsPage from '../pages/component/TabsPage';
import TooltipPage from '../pages/component/TooltipPage';

// Onboarding pages

// Error pages
import PageNotFound from '../shared/utils/PageNotFound';
*/
import CalendarPage from '@features/calendar/pages/Calendar';
import EventDetailsPage from '@features/calendar/pages/EventDetailsPage';
import Connections from '@features/community/pages/Connections';
import FeedPage from '@features/community/pages/Feed';
import Members from '@features/community/pages/Members';
import MyProfile from '@features/community/pages/MyProfile';
import PostDetail from '@features/community/pages/PostDetail';
import UserProfile from '@features/community/pages/UserProfile';
import FaqsPage from '@features/faqs/pages/FaqsPage';
import HomePage from '@features/home/pages/Home';
import MessagesPage from '@features/messages/pages/Messages';
import MyResourcesPage from '@features/resources/pages/MyResourcesPage';
import ResourceDetailPage from '@features/resources/pages/ResourceDetailPage';
import ResourceManagementPage from '@features/resources/pages/ResourceManagementPage';
import ResourcesPage from '@features/resources/pages/Resources';
import NotificationsPage from '@features/settings/pages/Notifications';
import SettingsPage from '@features/settings/pages/Settings';
import SpacePost from '@features/spaces/pages/SpacePost';
import SpacesPage from '@features/spaces/pages/Spaces';
import StartHerePage from '@features/start-here/pages/StartHerePage';
import { SupportPage } from '@features/support';
import TasksPage from '@features/tasks/pages/TasksPage';
import Feed from '../pages/community/Feed';
import Forum from '../pages/community/Forum';
import ForumPost from '../pages/community/ForumPost';
import Meetups from '../pages/community/Meetups';
import MeetupsPost from '../pages/community/MeetupsPost';
import UsersTabs from '../pages/community/UsersTabs';
import UsersTiles from '../pages/community/UsersTiles';
import PageNotFoundPublic from '../shared/utils/PageNotFoundPublic';

// Define route interface with children support
interface RouteConfig {
  path: string;
  component: React.ComponentType<any>;
  children?: RouteConfig[];
}

/**
 * Route configuration for the application
 * Defines public, protected, and onboarding routes
 */
const routes = {
  // Public routes (accessible without authentication)
  public: [
    // Authentication routes (public)
    { path: '/signin', component: SigninPage },
    { path: '/signup', component: SignupPage },
    { path: '/reset-password', component: ResetPasswordPage },
    { path: '/verify-email', component: VerifyEmailPage },
    { path: '/invitation', component: InvitationPage },
    { path: '/privacy-policy', component: PrivacyPolicyPage },
    { path: '/terms-and-conditions', component: TermsConditionsPage },
    { path: '/404', component: PageNotFoundPublic },
    { path: '*', component: PageNotFoundPublic },
  ],

  // Protected routes (require authentication)
  protected: [
    // Dashboard routes
    { path: '/', component: HomePage },

    // Settings routes
    {
      path: '/settings',
      children: [
        { path: 'account', component: SettingsPage },
        { path: 'organization', component: OrganizationSettingsPage },
        { path: 'admin-invitations', component: AdminInvitationsSettings },
        { path: 'member-invitations', component: MemberInvitationsManagement },
        { path: 'notifications', component: NotificationsPage },
      ],
    },

    // Community routes

    {
      path: '/community',
      children: [
        { path: 'connections', component: Connections },
        { path: 'connections/:userId', component: Connections },
        { path: 'profile', component: MyProfile },
        { path: 'profile/:userId', component: UserProfile },
        { path: 'members', component: Members },
        { path: 'members/:userId', component: Connections },
        { path: 'users-tabs', component: UsersTabs },
        { path: 'users-tiles', component: UsersTiles },
        { path: 'feed', component: FeedPage },
        { path: 'post/:id', component: PostDetail },
        { path: 'feed2', component: Feed },
        { path: 'forum', component: Forum },
        { path: 'forum-post', component: ForumPost },
        { path: 'meetups', component: Meetups },
        { path: 'meetups-post', component: MeetupsPost },
        { path: 'organizations', component: Organizations },
        { path: 'organizations/:organizationId', component: OrganizationProfile },
      ],
    },

    // Tasks routes
    {
      path: '/tasks',
      component: TasksPage,
    },
    // Messages routes

    { path: '/messages', component: MessagesPage },
    { path: '/messages/:conversationId', component: MessagesPage },

    // Support routes
    { path: '/support', component: SupportPage },

    // Spaces routes
    {
      path: '/spaces',
      children: [
        { path: '', component: SpacesPage },
        { path: ':spaceId', component: SpacePost },
      ],
    },

    // Resources routes
    { path: '/resources', component: ResourcesPage },
    { path: '/resources/management', component: ResourceManagementPage },
    { path: '/resources/my-resources', component: MyResourcesPage },
    { path: '/resources/:id', component: ResourceDetailPage },

    // Calendar routes
    { path: '/calendar', component: CalendarPage },
    { path: '/calendar/event/:id', component: EventDetailsPage },
    { path: '/calendar/:id', component: EventDetailsPage },

    // Faqs routes
    { path: '/faqs', component: FaqsPage },

    // Start Here routes
    { path: '/start-here', component: StartHerePage },

    /* { path: '/', component: Dashboard },
    { path: '/dashboard/analytics', component: Analytics },
    { path: '/dashboard/fintech', component: Fintech },

    // E-commerce routes
    { path: '/ecommerce/customers', component: Customers },
    { path: '/ecommerce/orders', component: Orders },
    { path: '/ecommerce/invoices', component: Invoices },
    { path: '/ecommerce/shop', component: Shop },
    { path: '/ecommerce/shop-2', component: Shop2 },
    { path: '/ecommerce/product', component: Product },
    { path: '/ecommerce/cart', component: Cart },
    { path: '/ecommerce/cart-2', component: Cart2 },
    { path: '/ecommerce/cart-3', component: Cart3 },
    { path: '/ecommerce/pay', component: Pay },

    // Campaign routes
    { path: '/campaigns', component: Campaigns },

    // Community routes
    { path: '/community', component: UsersTabs }, // Default community page
    { path: '/community/users-tabs', component: UsersTabs },
    { path: '/community/users-tiles', component: UsersTiles },
    { path: '/community/profile', component: Profile },
    { path: '/community/feed', component: Feed },
    { path: '/community/forum', component: Forum },
    { path: '/community/forum-post', component: ForumPost },
    { path: '/community/meetups', component: Meetups },
    { path: '/community/meetups-post', component: MeetupsPost },

    // Finance routes
    { path: '/finance/cards', component: CreditCards },
    { path: '/finance/transactions', component: Transactions },
    { path: '/finance/transaction-details', component: TransactionDetails },

    // Job routes
    { path: '/job/job-listing', component: JobListing },
    { path: '/job/job-post', component: JobPost },
    { path: '/job/company-profile', component: CompanyProfile },

    // Messaging and tasks
    { path: '/messages', component: Messages },
    { path: '/tasks/kanban', component: TasksKanban },
    { path: '/tasks/list', component: TasksList },
    { path: '/inbox', component: Inbox },
    { path: '/calendar', component: Calendar },

    // Settings routes
    { path: '/settings', component: Account }, // Default settings page
    { path: '/settings/account', component: Account },
    { path: '/settings/notifications', component: Notifications },
    { path: '/settings/apps', component: Apps },
    { path: '/settings/plans', component: Plans },
    { path: '/settings/billing', component: Billing },
    { path: '/settings/feedback', component: Feedback },

    // Utility routes
    { path: '/utility/changelog', component: Changelog },
    { path: '/utility/roadmap', component: Roadmap },
    { path: '/utility/faqs', component: Faqs },
    { path: '/utility/empty-state', component: EmptyState },
    { path: '/utility/404', component: PageNotFound },
    { path: '/not-found', component: PageNotFound },

    // Component routes
    { path: '/component/button', component: ButtonPage },
    { path: '/component/form', component: FormPage },
    { path: '/component/dropdown', component: DropdownPage },
    { path: '/component/alert', component: AlertPage },
    { path: '/component/modal', component: ModalPage },
    { path: '/component/pagination', component: PaginationPage },
    { path: '/component/tabs', component: TabsPage },
    { path: '/component/breadcrumb', component: BreadcrumbPage },
    { path: '/component/badge', component: BadgePage },
    { path: '/component/avatar', component: AvatarPage },
    { path: '/component/tooltip', component: TooltipPage },
    { path: '/component/accordion', component: AccordionPage },
    { path: '/component/icons', component: IconsPage }, */
  ],

  // Onboarding routes (require authentication but are part of onboarding flow)
  onboarding: [
    { path: '/onboarding-1', component: Onboarding01Page },
    { path: '/onboarding-2', component: Onboarding02Page },
    { path: '/onboarding-3', component: Onboarding03Page },
    { path: '/onboarding-4', component: Onboarding04Page },
  ],
};

export default routes;
